import { Alert, Snackbar, Typography } from '@mui/material'
import custom from '../../styles/mui/szVariables.json'

export default function Notification({ 
        title, message, type, setError, hposition }: any) {
    return (
        <Snackbar autoHideDuration={5000} open={!!message} 
            onClose={()=>setError('')}
            anchorOrigin={{ vertical: 'bottom', 
                            horizontal: hposition || 'center' }} 
            sx={{ 
                mt: custom.spacing.xs,
                // mr: custom.spacing.xxs, 
                position: 'relative' 
            }}>
            <Alert variant='outlined' 
                severity={type} 
                id='notification'>
                <Typography color={type}
                    variant='szBody.Bold.Medium' 
                    id="notificationTitle">
                    {title}
                </Typography>
                {message.split('\n').map((m:string)=>(
                    <Typography component="p" 
                        mt={custom.spacing.xxs} 
                        id="notificationMessage"
                        variant='szBody.Regular.Small'>
                    {m}
                    </Typography>
                ))}
            </Alert>
        </Snackbar>
    )
}

 
      